module.exports = __webpack_public_path__ + "img/1.7.5-2.8c07eb05.jpg";